import { render, staticRenderFns } from "./studentsQsModal.vue?vue&type=template&id=b6e74f28&scoped=true"
import script from "./studentsQsModal.vue?vue&type=script&lang=js"
export * from "./studentsQsModal.vue?vue&type=script&lang=js"
import style0 from "./studentsQsModal.vue?vue&type=style&index=0&id=b6e74f28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e74f28",
  null
  
)

export default component.exports